import React, {
  cloneElement,
  FC,
  ReactElement,
  useEffect,
  useRef,
  useState
} from 'react';

import cn from 'classnames';

import Icon from '@components/Icon';

import styles from './index.module.less';

interface CarouselAutoProps {
  width: number;
  height?: number;
  children?: any
}

export const CarouselAuto: FC<CarouselAutoProps> = (props) => {
  const { children, width, height } = props;
  const _children = [...React.Children.toArray(children)];

  const brfore4 = _children.slice(0, 4).map((item, index) => {
    // clone 是为了更改key值 避免key重复
    return cloneElement(item as ReactElement, { key: `${index}_cloneElement` });
  });
  _children.push(...brfore4); // 拼接4个element是为了 首尾更好的衔接

  const [currentIndex, setCurrentIndex] = useState(0);
  const timeRef = useRef(null);

  // eslint-disable-next-line no-undef
  const slidersRef = useRef<HTMLCollectionOf<Element>>();

  const onSetInterval = () => {
    timeRef.current = setInterval(() => {
      setCurrentIndex((i) => {
        const count = i === _children.length - 1 ? 0 : i + 1;
        return count;
      });
    }, 5000);
  };

  useEffect(() => {
    slidersRef.current = document.getElementsByClassName(styles.slider);
    onSetInterval();
    return () => {
      clearInterval(timeRef.current);
    };
  }, []);

  const setCenterCardStyle = () => {
    // 当前卡片的样式
    slidersRef.current[currentIndex].className = cn(
      styles.slider,
      styles.sliderCenter
    );
  };

  const setStyle = ({ index1, className, index2 }) => {
    const el = slidersRef.current[index1] || slidersRef.current[index2];
    el.className = cn(styles.slider, className);
  };

  useEffect(() => {
    Array.from(slidersRef.current).forEach((element) => {
      // 设置基础样式
      element.className = styles.slider;
    });
    // 设置中间卡片样式
    setCenterCardStyle();
    /**
     * index1: 定位卡片的位置
     * index2: index1不存在时，使用index2定位卡片，index2一定存在
     * className: 当前位置对应的样式
     */
    [
      {
        index1: currentIndex - 1,
        className: styles.sliderLeft1,
        index2: slidersRef.current.length + currentIndex - 1
      },
      {
        index1: currentIndex - 2,
        className: styles.sliderLeft,
        index2: slidersRef.current.length + currentIndex - 2
      },
      {
        index1: currentIndex + 1,
        className: styles.sliderRight1,
        index2: currentIndex - slidersRef.current.length + 1
      },
      {
        index1: currentIndex + 2,
        className: styles.sliderRight,
        index2: currentIndex - slidersRef.current.length + 2
      }
    ].forEach((item) => setStyle(item));
  }, [currentIndex]);

  const clickSlider = (index) => {
    clearInterval(timeRef.current);
    setCurrentIndex(index);
    onSetInterval();
  };

  const backwardHandle = () => {
    const i =
      currentIndex === slidersRef.current.length - 1 ? 0 : currentIndex + 1;
    clearInterval(timeRef.current);
    setCurrentIndex(i);
    onSetInterval();
  };

  const forwardHandle = () => {
    const i =
      currentIndex === 0 ? slidersRef.current.length - 1 : currentIndex - 1;
    clearInterval(timeRef.current);
    setCurrentIndex(i);
    onSetInterval();
  };

  return (
    <div>
      <div
        className={styles.container}
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        {_children.map((item, index) => {
          return (
            <div
              className={styles.slider}
              key={index}
              onClick={() => {
                clickSlider(index);
              }}
            >
              {item}
            </div>
          );
        })}
      </div>
      <div className={styles.btnContaier}>
        <div className={cn(styles.btn)} onClick={forwardHandle}>
          <Icon name="backward" className={styles.icon} />
        </div>
        <div className={cn(styles.btn)} onClick={backwardHandle}>
          <Icon name="forward" className={styles.icon} />
        </div>
      </div>
    </div>
  );
};
